import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }      from '../api/api.service';
import { ConfirmService }  from '../messages/confirm/confirm.service';
import { GroupModel }      from './typings/group-rights.group';
import { GroupRightModel } from './typings/group-right';

@Injectable({
  providedIn: 'root'
})
export class GroupRightsService {
  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private translateService: TranslateService
  ) {}

  create ( group : GroupModel ) : Promise<GroupModel> {


    return this.apiService.post('/groups', group, 'group');


  }

  delete ( group : GroupModel ) : Promise<any> {


    return this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.DELETE_GROUP'))
      .then(() => this.apiService.delete('/group', group.group_name));


  }

  get () : Promise<Array<GroupModel>> {
    return this.apiService.get('/groups', ['*', '*']);
  }

  getAllRights () : Promise<Array<GroupRightModel>> {
    return this.apiService.get('/system/group_right_objects')
      .then(( rights : Array<GroupRightModel> ) => {
        rights.forEach(( right : GroupRightModel ) => {
          right.allow = false;
        });

        return rights;
      });
  }

  getRights ( group : GroupModel ) : Promise<GroupModel> {


    return this.apiService.get(`/group/${ group.group_name }`);


  }

  update ( group : GroupModel ) : Promise<GroupModel> {


    return this.apiService.patch('/group', group, 'group');


    };


  }
